import React from "react";
import { Card } from "primereact/card";

const MonthlyReview: React.FC = () => {
  return (
    <div className="p-2">
      <h2 className="text-color mb-4">Monthly Operations Review</h2>
      <Card>
        <div className="flex flex-column align-items-center justify-content-center py-6 text-color-secondary">
          <i className="pi pi-chart-line text-5xl mb-3" style={{ color: "#cbd5e1" }} />
          <p className="text-lg font-semibold mb-1">Coming Soon</p>
          <p className="text-sm">Monthly dashboard is under construction.</p>
        </div>
      </Card>
    </div>
  );
};

export default MonthlyReview;
